// CU-LS-M1-067: lds-api serves a portal user's menu only to the login email an admin bound to that user ID.
const EMAIL = /^[^@\s]+@[^@\s]+$/;

export const bindingErrors = ({ userId, principal }) => {
  const errors = {};
  if (!String(userId ?? "").trim()) errors.userId = "User ID is required";
  const email = String(principal ?? "").trim();
  if (!email) errors.principal = "Owner email is required";
  else if (!EMAIL.test(email)) errors.principal = "Owner email must be an email address";
  return errors;
};

export const bindRequest = ({ userId, principal }) => ({
  data: { userId: String(userId).trim(), principal: String(principal).trim().toLowerCase() },
});

/** The signed-in user's own binding, so an admin whose record is still unbound can bind it here. */
export const selfBinding = (userInfo) => ({
  userId: userInfo?.id ?? "",
  principal: userInfo?.email ?? "",
});

/** get-repository answers 403 when the user ID is not bound to this login (or is bound to another one). */
export const isUnboundRefusal = (error) => error?.status === 403;
